import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import { DashboardServicesService } from '../../services/dashboard-services.service';
import { DashboardPanel } from '../../models/panel';
import { ThemeService } from '../../theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-lineal-chart',
  standalone: true,
  imports: [CommonModule, ChartModule],
  templateUrl: './lineal-chart.component.html',
  styleUrl: './lineal-chart.component.scss'
})
export class LinealChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() datasets!: any[];
  @Input() method!: string;
  @Input() labels!: any[];
  @Input() clientNumber!: number;
  @Input() id!: string;

  data: any;
  chartOptions: any;
  private darkMode = false;
  private sub!: Subscription;

  constructor(private dashboardSrv: DashboardServicesService, private themeService: ThemeService) {
    this.darkMode = localStorage.getItem('theme') === 'dark';
    this.sub = themeService.changeTheme.subscribe(v => { this.darkMode = v; this.buildOptions(); });
  }

  ngOnInit() { this.buildData(); this.buildOptions(); this.loadDataChart(); }

  ngOnChanges(changes: SimpleChanges) { this.buildData(); }

  ngOnDestroy() { this.sub?.unsubscribe(); }

  private buildData() {
    this.data = { labels: this.labels, datasets: this.datasets };
  }

  private buildOptions() {
    const color = this.darkMode ? '#fff' : '#182de7';
    this.chartOptions = {
      scales: {
        y: { ticks: { color }, grid: { display: false } },
        x: { ticks: { color }, grid: { display: false } }
      },
      plugins: {
        legend: { display: true, labels: { usePointStyle: true, color, font: { size: 13 } } }
      },
      responsive: true,
      maintainAspectRatio: false
    };
  }

  private loadDataChart() {
    if (this.method) {
      this.dashboardSrv.infoPanel(this.method, this.clientNumber).subscribe({
        next: (resp: DashboardPanel) => {
          if (resp.type === 'bar') resp.dataChart[0].borderColor = resp.dataChart[0].borderColors;
          resp.dataChart.forEach(d => {
            d.fill = false;
            d.backgroundColor[0] = d.borderColor?.toString();
          });
          this.data = { ...this.data, datasets: resp.dataChart, labels: resp.labelsChart };
        }
      });
    }
  }
}
